import { S1_div, S2_div } from 'file:///root/project/node_modules/.cache/react-style-loader/components_SortableList_SortableList-hi2E.styl';
import React, { PureComponent, ComponentType } from 'react';
import { SortableContainer, SortableElement, SortableHandle, SortEnd, SortStart } from 'react-sortable-hoc';

interface SortableListProps {
    onSwap: (oldIndex: number, newIndex: number) => void;
    children?: React.ReactNode;
    [key: string]: unknown;
}

interface SortableListState {
    draggingIndex: number | null;
}

export default class SortableList extends PureComponent<SortableListProps, SortableListState> {
    state: SortableListState = {
        draggingIndex: null,
    };

    onSortEnd = ({ oldIndex, newIndex }: SortEnd) => {
        this.setState({ draggingIndex: null });
        this.props.onSwap(oldIndex, newIndex);
    };

    onSortStart = ({ index }: SortStart) => this.setState({ draggingIndex: index });

    render() {
        const { onSwap, ...rest } = this.props;
        const { draggingIndex } = this.state;

        return (
            <SortableListContainer
                {...rest}
                lockAxis='y'
                useDragHandle={true}
                onSortStart={this.onSortStart}
                onSortEnd={this.onSortEnd}
                draggingIndex={draggingIndex}
                lockToContainerEdges={true}
            />
        );
    }
}

interface ContainerProps {
    onSwap?: unknown;
    showHandle?: boolean;
    visibleHandle?: boolean;
    handleLeft?: string;
    draggingIndex?: number | null;
    className?: string;
    children?: React.ReactNode;
    [key: string]: unknown;
}

class SortableListContainerInner extends PureComponent<ContainerProps> {
    static defaultProps = {
        showHandle: true,
        visibleHandle: false,
    };

    render() {
        const {
            onSwap,
            showHandle,
            visibleHandle,
            handleLeft,
            draggingIndex,
            className,
            children,
            ...props
        } = this.props;

        return <div {...(props as React.HTMLAttributes<HTMLDivElement>)}>
            {React.Children.map(children, (child, index) =>
                <Item
                    key={index}
                    visibleHandle={visibleHandle}
                    handleLeft={handleLeft}
                    showHandle={showHandle}
                    index={index}
                    data-disabled={draggingIndex != null && draggingIndex !== index}
                >
                    {child}
                </Item>,
            )}
        </div>;
    }
}

// react-sortable-hoc's generic HOCs inject sortable props; their inferred prop
// unions do not compose cleanly with our own props, so the wrapped components are
// widened at these (3rd-party) boundaries. Inner components above are fully typed.
const SortableListContainer = SortableContainer(SortableListContainerInner) as ComponentType<any>;

interface ItemProps {
    showHandle?: boolean;
    visibleHandle?: boolean;
    handleLeft?: string;
    children?: React.ReactNode;
}

const Item = SortableElement(
    ({ showHandle, visibleHandle, handleLeft, children }: ItemProps) =>
        <ItemRoot>
            {!showHandle ? null :
                <Handle
                    data-visible={visibleHandle}
                    style={!handleLeft ? undefined : { left: handleLeft }}
                />
            }

            {children}
        </ItemRoot>,
) as ComponentType<any>;

const Handle = SortableHandle(
    (props: React.HTMLAttributes<HTMLDivElement>) => <HandleRoot {...props} />,
) as ComponentType<any>;

const ItemRoot = S1_div.withComponent("div");
const HandleRoot = S2_div.withComponent("div");